<template>
  <div style="height: 100%;">
    <PesquisaPacienteModal
        v-if="modalSelecionarPaciente"
        v-model="modalSelecionarPaciente"
        @fecharModalPesquisaPaciente="fecharModalSelecionarPaciente"
        @confirmarPacienteSelecionado="selecionarPaciente"
    />
    <PacienteSalaEsperaModal
        v-if="modalVisualizarPaciente"
        v-model="modalVisualizarPaciente"
        :paciente="pacienteSelecionado"
        @fecharModalVisualizarPacienteSalaEspera="fecharModalVisualizarPaciente"
        @removerPacienteSalaEspera="removerPacienteEspera"
    />
    <div style="height: 100%;">
      <div class="primary--text text-titulo-sala-espera">
        <div>
          <label>Sala de Espera</label>
          <v-icon color="primary" class="ml-2">mdi-sofa-single-outline</v-icon>
          <v-icon color="primary">mdi-floor-lamp</v-icon>
          <v-icon color="primary">mdi-clock-outline</v-icon>
        </div>
        <span v-if="totalItens > 0">Total: {{ totalItens }}</span>
      </div>
      <div class="container-sala-espera">
        <v-row>
          <v-col :key="paciente.id" v-for="paciente in pacientesList" cols="12" xs="12" sm="6" md="4" lg="2">
            <paciente-espera-card
                :paciente="paciente"
                @visualizarItem="abrirModalVisualizarPaciente"
            />
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" lg="2">
            <adicionar-paciente-espera-card @adicionarPaciente="abrirModalSelecionarPaciente"/>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import SockJS from 'sockjs-client'
import Stomp from 'webstomp-client'
import {actionTypes} from '@/core/constants'
import PacienteEsperaCard from '@/views/pages/salaEspera/PacienteEsperaCard.vue'
import AdicionarPacienteEsperaCard from '@/views/pages/salaEspera/AdicionarPacienteEsperaCard.vue'
import PesquisaPacienteModal from '@/views/modais/PesquisaPacienteModal.vue'
import PacienteSalaEsperaModal from '@/views/modais/PacienteSalaEsperaModal.vue'

export default {
    name: 'SalaEspera',
    components: {
        PacienteSalaEsperaModal, PesquisaPacienteModal, AdicionarPacienteEsperaCard, PacienteEsperaCard
    },
    data() {
        return {
            socket: null,
            stompClient: null,
            idEmpresa: null,
            pacientesList: [],
            totalItens: 0,
            modalSelecionarPaciente: false,
            modalVisualizarPaciente: false,
            pacienteSelecionado: null,
        }
    },
    async mounted() {
        this.setarIdEmpresa()
        await this.buscarPacientesEmEspera()
        this.conectar()
    },
    methods: {
        setarIdEmpresa() {
            this.idEmpresa = 1
        },
        async buscarPacientesEmEspera() {
            const resposta = await this.$store.dispatch(actionTypes.SALA_ESPERA.BUSCAR_DADOS)
            if (resposta) {
                this.pacientesList = resposta.items
                this.totalItens = resposta.totalElements
            }
        },
        abrirModalSelecionarPaciente() {
            this.modalSelecionarPaciente = true
        },
        fecharModalSelecionarPaciente() {
            this.modalSelecionarPaciente = false
        },
        abrirModalVisualizarPaciente(pacienteSelecionado) {
            this.modalVisualizarPaciente = true
            this.pacienteSelecionado = pacienteSelecionado
        },
        fecharModalVisualizarPaciente() {
            this.modalVisualizarPaciente = false
            this.pacienteSelecionado = null
        },
        async selecionarPaciente(paciente) {
            this.fecharModalSelecionarPaciente()
            await this.$store.dispatch(actionTypes.SALA_ESPERA.ADICIONAR_PACIENTE, paciente.id)
        },
        async removerPacienteEspera(idSalaEspera) {
            await this.$store.dispatch(actionTypes.SALA_ESPERA.REMOVER_SALA_ESPERA, idSalaEspera)
            this.fecharModalVisualizarPaciente()
        },
        conectar() {
            this.socket = new SockJS(this.getSocketURL())
            this.stompClient = Stomp.over(this.socket)
            this.stompClient.debug = () => {
            }
            this.stompClient.connect({}, () => {
                this.stompClient.subscribe(`/topic/eventoBuscarPacientesSalaEspera=${this.idEmpresa}`, async () => {
                    await this.buscarPacientesEmEspera()
                })
            },
            error => {
                console.log('--------- Falha ao conectar com o websocket!')
                console.log(error)
            }
            )
        },
    }
}
</script>

<style scoped lang="stylus">

.text-titulo-sala-espera
  border-bottom 1px solid #ddd
  font-weight bold
  margin-bottom 20px
  display flex
  justify-content space-between

.container-sala-espera
  height 90%
  background-color var(--theme-primary)
  border-radius 5px
  padding 15px
  font-weight bold
  color white
  overflow-y auto

</style>